import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../context/AuthContext";
import InputLebelComponent from "../InputLebel/InputLebelComponent";
import { Button } from "react-bootstrap";
import { AlertDanger, AlertInfo, AlertSuccess } from "../Alerts/Alert";
import { Link } from "react-router-dom";

//import API
import updateJob from "../../apis/updateJob";
import { FIRM_IMAGE_BASE } from "../../config/env";
import getFirmAccessList from "../../apis/getFirmAccessList";
import getJobEditDetails from "../../apis/getJobEditDetails";
import LoadingPageSm from "../CommonComponent/LoadingPageSm";

import BlockHeader from "../Headers/BlockHeader";

const EditJobPosting = (props) => {
  const { jobSlug } = props;

  const { userDetails } = useAuthContext();
  const user_slug = JSON.parse(userDetails).user_slug;
  const user_primary_role = JSON.parse(userDetails).user_primary_role;

  const [roleTitle, setRoleTitle] = useState("");
  const [hasEditPermission, setHasEditPermission] = useState(false);
  const [firmList, setFirmList] = useState(false);
  const [description, setDescription] = useState("");
  const [isFirmListLoading, setIsFirmListLoading] = useState(true);
  const [selectedFirmList, setSelectedFirmList] = useState([]);
  const [selectedJobSlug, setSelectedJobSlug] = useState("");
  const [skills, setSkills] = useState("");
  const [experience, setExperience] = useState("");
  const [jobType, setJobType] = useState("1");
  const [contractLength, setContractLength] = useState("");
  const [compensation, setCompensation] = useState("");
  const [locationRequirement, setLocationRequirement] = useState("");
  const [other, setOther] = useState("");
  const [employerName, setEmployerName] = useState("");
  const [employerDescription, setEmployerDescription] = useState("");
  const [benefits, setBenefits] = useState("");
  const [workingHours, setWorkingHours] = useState("");
  const [closingDate, setClosingDate] = useState("");
  const [jobRequirements, setJobRequirements] = useState("");

  const [applicationDetails, setApplicationDetails] = useState("");
  const [employerContact, setEmployerContact] = useState("");
  const [employerWebsite, setEmployerWebsite] = useState("");

  const [buttonText, setButtonText] = useState("Save Changes");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [hasSubmitError, setHasSubmitError] = useState(false);
  const [isValidSubmit, setIsValidSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

  const [isJobDetailsLoading, setIsJobDetailsLoading] = useState(true);

  const [apiResponse, setApiResponse] = useState("");

  useEffect(() => {
    if (jobSlug !== undefined && user_slug !== undefined) {
      getJobDetails();
    }
  }, [jobSlug, user_slug]);

  const getJobDetails = () => {
    Promise.all([getJobEditDetails(user_slug, jobSlug)])
      .then(async ([data]) => {
        if (data?.data?.job_details) {
          await setHasEditPermission(true);
          await setRoleTitle(data.data.job_details.job_title);
          await setDescription(data.data.job_details.job_description);

          if (data.data.job_details.application_details !== null) {
            await setApplicationDetails(
              data.data.job_details.application_details
            );
          }

          if (data.data.job_details.employer_contact !== null) {
            await setEmployerContact(data.data.job_details.employer_contact);
          }

          if (data.data.job_details.employer_website !== null) {
            await setEmployerWebsite(data.data.job_details.employer_website);
          }

          if (data.data.job_details.job_requirements !== null) {
            await setJobRequirements(data.data.job_details.job_requirements);
          }

          if (data.data.job_details.experience_required !== null) {
            await setExperience(data.data.job_details.experience_required);
          }

          if (data.data.job_details.job_type !== null) {
            await setJobType(data.data.job_details.job_type);
          }

          if (data.data.job_details.contract_length !== null) {
            await setContractLength(data.data.job_details.contract_length);
          }

          if (data.data.job_details.compensation !== null) {
            await setCompensation(data.data.job_details.compensation);
          }

          if (data.data.job_details.location_requirement !== null) {
            await setLocationRequirement(
              data.data.job_details.location_requirement
            );
          }

          if (data.data.job_details.employer_name !== null) {
            await setEmployerName(data.data.job_details.employer_name);
          }

          if (data.data.job_details.employer_description !== null) {
            await setEmployerDescription(
              data.data.job_details.employer_description
            );
          }

          if (data.data.job_details.benefits !== null) {
            await setBenefits(data.data.job_details.benefits);
          }

          if (data.data.job_details.working_hours !== null) {
            await setWorkingHours(data.data.job_details.working_hours);
          }

          if (data.data.job_details.closing_date !== null) {
            await setClosingDate(data.data.job_details.closing_date);
          }

          if (data.data.job_details.other !== null) {
            await setOther(data.data.job_details.other);
          }

          if (data.data.job_details.job_firm_access !== null) {
            const firmArray = data.data.job_details.job_firm_access.split(",");
            await setSelectedFirmList(firmArray);
          }

          await setSelectedJobSlug(data.data.job_details.job_slug);

          await getFirmList();
          setIsJobDetailsLoading(false);
        } else {
          setIsJobDetailsLoading(false);
          setHasEditPermission(false);
          setApiResponse([data.data.message]);
        }
      })
      .catch((err) => {
        setHasEditPermission(false);
        setIsJobDetailsLoading(false);
      });
  };

  const getFirmList = () => {
    Promise.all([getFirmAccessList(user_slug)])
      .then(async ([data]) => {
        if (data?.data?.firmList) {
          setIsFirmListLoading(false);
          setFirmList(data.data.firmList);

          var firmCheckedIds = [];

          data.data.firmList.map((item) => {
            return firmCheckedIds.push(item.firm_id);
          });
        } else {
          setIsFirmListLoading(false);
        }
      })
      .catch((err) => {
        setIsFirmListLoading(false);
        console.log(err);
      });
  };

  const displayRelatedFirms = () => {
    if (isFirmListLoading) {
      return displayLoadingBlock();
    } else {
      return displayFirmList();
    }
  };

  const updateSelectedFirmIds = (id) => {
    let ids = [...selectedFirmList];
    const index = selectedFirmList.indexOf(id);

    if (index > -1) {
      for (let i = 0; i < ids.length; i++) {
        if (ids[i] === id) {
          ids.splice(i, 1);
        }
      }
    } else {
      ids.push(id);
    }
    setSelectedFirmList(ids);
  };

  const handleRoleTitleChange = (e) => {
    setRoleTitle(e.target.value);
  };

  // const handleSkillChange = (e) => {
  //   setSkills(e.target.value);
  // };

  const handleLocationRequirementChange = (e) => {
    setLocationRequirement(e.target.value);
  };

  const handleChangeJobType = (type) => {
    setJobType(type);
  };

  // const handleExperienceChange = (e) => {
  //   setExperience(e.target.value);
  // };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleChangeEmployerName = (e) => {
    setEmployerName(e.target.value);
  };

  const handleEmployerDescriptionChange = (e) => {
    setEmployerDescription(e.target.value);
  };

  const handleContractLengthChange = (e) => {
    setContractLength(e.target.value);
  };

  const handleBenefitsChange = (e) => {
    setBenefits(e.target.value);
  };

  const handleOtherChange = (e) => {
    setOther(e.target.value);
  };

  const handleCompensationChange = (e) => {
    setCompensation(e.target.value);
  };

  const handleApplicationDetailsChange = (e) => {
    setApplicationDetails(e.target.value);
  };

  const handleEmployerContactChange = (e) => {
    setEmployerContact(e.target.value);
  };

  const handleEmployerWebsiteChange = (e) => {
    setEmployerWebsite(e.target.value);
  };

  const handleWorkingHoursChange = (e) => {
    setWorkingHours(e.target.value);
  };

  const handleClosingDateChange = (e) => {
    setClosingDate(e.target.value);
  };

  const handleJobRequirementsChange = (e) => {
    setJobRequirements(e.target.value);
  };

  const displayMainContent = () => {
    return displayFormBlock();
  };

  const handleFormSubmit = () => {
    //disable button
    setIsButtonDisabled(true);

    //change button text while processing
    setButtonText("Processing, please wait...");

    //change alert block content
    setHasSubmitError(false);
    setErrorMessage(false);
    setIsValidSubmit(false);
    setSuccessMessage(false);

    let isInvalid = 0;
    let errMessage = [];

    if (roleTitle.trim().length === 0) {
      isInvalid = 1;
      errMessage.push("Enter role title");
    }

    if (description.trim().length === 0) {
      isInvalid = 1;
      errMessage.push("Enter description");
    }

    if (selectedFirmList.length === 0) {
      isInvalid = 1;
      errMessage.push("Select at least one firm");
    }

    if (isInvalid === 1) {
      setErrorMessage(errMessage);
      setHasSubmitError(true);
      setIsButtonDisabled(false);
      setButtonText("Save Changes");
    } else {
      submitForm();
    }
  };

  useEffect(() => {
    setContractLength("");
  }, [jobType]);

  const submitForm = () => {
    let errMessage = [];
    let succMessage = [];

    let formData = {
      user_slug: user_slug,
      job_title: roleTitle,
      job_description: description,
      firm_ids: selectedFirmList,
      job_slug: selectedJobSlug,
      required_skill_set: skills,
      experience_required: experience,
      job_requirements: jobRequirements,
      job_type: jobType,
      contract_length: contractLength,
      compensation: compensation,
      location_requirement: locationRequirement,
      other: other,
      employer_name: employerName,
      employer_description: employerDescription,
      benefits: benefits,
      working_hours: workingHours,
      closing_date: closingDate,
      application_details: applicationDetails,
      employer_contact: employerContact,
      employer_website: employerWebsite,
    };

    try {
      updateJob(formData).then(async (data) => {
        if (data?.data) {
          if (data.data.status === 1) {
            succMessage.push(data.data.message);
            setSuccessMessage(succMessage);
            setIsValidSubmit(true);
            setHasSubmitError(false);
            setIsButtonDisabled(true);
            setButtonText("Save Changes");
            setTimeout(() => {
              window.location.replace("/job/my-jobs");
            }, 500);
          } else if (data.data.status === 0) {
            errMessage.push(data.data.message);
            setErrorMessage(errMessage);
            setHasSubmitError(true);
            setIsButtonDisabled(false);
            setButtonText("Save Changes");
          } else {
            errMessage.push("Error happened. Unable to Save Changes.");
            setErrorMessage(errMessage);
            setHasSubmitError(true);
            setIsButtonDisabled(false);
            setButtonText("Save Changes");
          }
        } else {
          errMessage.push("Error happened. Unable to Save Changes");
          setErrorMessage(errMessage);
          setHasSubmitError(true);
          setIsButtonDisabled(false);
          setButtonText("Save Changes");
        }
      });
    } catch (error) {
      errMessage.push("Error happened. Network error happened.");
      setErrorMessage(errMessage);
      setHasSubmitError(true);
      setIsButtonDisabled(false);
      setButtonText("Save Changes");
    }
  };

  const displayFirmList = () => {
    if (firmList) {
      return (
        <div className="d-block">
          <InputLebelComponent title="Select firms to be notified of opportunity" />
          <div className="d-flex mt-2">
            {firmList.map(function (item) {
              return (
                <div
                  key={item.firm_id}
                  className="d-block me-4 border border-info rounded p-2"
                >
                  <div className="form-check mt-1 d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={item.firm_id}
                      onChange={() => updateSelectedFirmIds(item.firm_id)}
                      id={"firm-id-" + item.firm_id}
                      checked={
                        selectedFirmList.includes(item.firm_id) ? true : false
                      }
                    />
                    <div
                      className="firm-logo-sm-custom ms-2"
                      alt={item.firm_name}
                      style={{
                        backgroundImage: `url("${
                          FIRM_IMAGE_BASE + item.firm_logo
                        }")`,
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    }
  };

  const displayLoadingBlock = () => {
    return (
      <div>
        <span>Loading related firm list</span>
      </div>
    );
  };

  const displayTopBlock = () => {
    return (
      <BlockHeader
        title={"Edit Job Details"}
        subText={"Edit a posting within your firm"}
      />
    );
  };

  const displayForm = () => {
    return (
      <>
        {isJobDetailsLoading ? (
          <LoadingPageSm title={"Loading job details..."} />
        ) : hasEditPermission ? (
          <div className="d-block mb-5">
            <div className="card-custom bg-white">
              <div className="card-body">
                <form id="create-frm">
                  {displayJobBlock()}
                  {displayRelatedFirms()}
                  {displayStatusMessage()}

                  <div className="d-flex justify-content-end">
                    {displayCancelButton()}
                    {displaySubmitButton()}
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : (
          <AlertInfo title={"Oops"} message={apiResponse} />
        )}
      </>
    );
  };

  const displayJobBlock = () => {
    return (
      <div className="d-block mb-4">
        <div className="d-block">
          <div className="form-input-holder">
            <InputLebelComponent title="Job Title" />
            <div className="d-block">
              <input
                type="text"
                className="form-control"
                id="role-title"
                placeholder="Enter job title"
                onChange={handleRoleTitleChange}
                value={roleTitle}
                autoComplete="off"
              />
            </div>
          </div>
        </div>

        <div className="d-block">
          <div className="form-input-holder">
            <InputLebelComponent title="Employer Name" />
            <div className="d-block">
              <input
                type="text"
                className="form-control"
                id="role-title"
                placeholder="Enter employer name"
                onChange={handleChangeEmployerName}
                value={employerName}
                autoComplete="off"
              />
            </div>
          </div>
        </div>
        <div className="d-block">
          <div className="form-input-holder">
            <InputLebelComponent title="Employer Description" />
            <div className="d-block">
              <textarea
                type="textarea"
                className="form-control"
                id="description"
                placeholder="Enter employer description"
                onChange={handleEmployerDescriptionChange}
                value={employerDescription}
                autoComplete="off"
                rows={6}
              />
            </div>
          </div>
        </div>
        <div className="d-block">
          <div className="form-input-holder">
            <InputLebelComponent title="Job Description" />
            <div className="d-block">
              <textarea
                type="textarea"
                className="form-control"
                id="description"
                placeholder="Enter job description"
                onChange={handleDescriptionChange}
                value={description}
                autoComplete="off"
                rows={6}
              />
            </div>
          </div>
        </div>
        <div className="d-block">
          <div className="form-input-holder">
            <InputLebelComponent title="Benefits" />
            <div className="d-block">
              <textarea
                type="textarea"
                className="form-control"
                id="description"
                placeholder="Enter benefits"
                onChange={handleBenefitsChange}
                value={benefits}
                autoComplete="off"
                rows={6}
              />
            </div>
          </div>
        </div>

        <div className="d-block d-md-flex d-lg-flex d-xl-flex row">
          <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
            <div className="form-input-holder">
              <InputLebelComponent title="Working Hours" />
              <div className="d-block">
                <input
                  type="text"
                  className="form-control"
                  id="working_hours"
                  placeholder="Enter working hours"
                  autocomplete="off"
                  value={workingHours}
                  onChange={handleWorkingHoursChange}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
            <div className="form-input-holder">
              <InputLebelComponent title="Closing On" />
              <div className="d-block">
                <input
                  type="date"
                  className="form-control"
                  id="closing_date"
                  placeholder="Enter date"
                  autocomplete="off"
                  value={closingDate}
                  onChange={handleClosingDateChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="d-block">
          <div className="form-input-holder">
            <InputLebelComponent title="Job Requirements" />
            <div className="d-block">
              <textarea
                type="textarea"
                className="form-control"
                id="jobRequirements"
                placeholder="Enter job requirements"
                onChange={handleJobRequirementsChange}
                value={jobRequirements}
                autoComplete="off"
                rows={6}
              />
            </div>
          </div>
        </div>

        <div className="d-block">
          <div className="form-input-holder">
            <InputLebelComponent title="Application Details" />
            <div className="d-block">
              <textarea
                type="textarea"
                className="form-control"
                id="jobRequirements"
                placeholder="Enter application details"
                onChange={handleApplicationDetailsChange}
                value={applicationDetails}
                autoComplete="off"
                rows={6}
              />
            </div>
          </div>
        </div>

        <div className="d-block d-md-flex d-lg-flex d-xl-flex row">
          <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
            <div className="form-input-holder">
              <InputLebelComponent title="Employer Contact (optional)" />
              <div className="d-block">
                <input
                  type="text"
                  className="form-control"
                  id="skills"
                  placeholder="Enter contact"
                  autocomplete="off"
                  value={employerContact}
                  onChange={handleEmployerContactChange}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
            <div className="form-input-holder">
              <InputLebelComponent title="Website (optional)" />
              <div className="d-block">
                <input
                  type="text"
                  className="form-control"
                  id="experience"
                  placeholder="Enter website"
                  autocomplete="off"
                  value={employerWebsite}
                  onChange={handleEmployerWebsiteChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="d-block d-md-flex d-lg-flex d-xl-flex row">
          <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
            <div className="form-input-holder">
              <InputLebelComponent title="Select Job Type" />
              <div className="d-flex">
                <Button
                  variant={jobType === "1" ? "primary" : "outline-secondary"}
                  onClick={() => handleChangeJobType("1")}
                  size="sm"
                  className="me-2 rounded-lg"
                >
                  Permanent
                </Button>
                <Button
                  variant={jobType === "2" ? "primary" : "outline-secondary"}
                  onClick={() => handleChangeJobType("2")}
                  className="rounded-lg"
                >
                  Contract
                </Button>
              </div>
            </div>
          </div>
          {jobType === "2" ? (
            <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
              <div className="form-input-holder">
                <InputLebelComponent title="Contract Length (optional)" />
                <div className="d-block">
                  <input
                    type="text"
                    className="form-control"
                    id="contract"
                    placeholder="Enter contract length"
                    autocomplete="off"
                    value={contractLength}
                    onChange={handleContractLengthChange}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>

        <div className="d-block d-md-flex d-lg-flex d-xl-flex row">
          <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
            <div className="form-input-holder">
              <InputLebelComponent title="Compensation (optional)" />
              <div className="d-block">
                <input
                  type="text"
                  className="form-control"
                  id="compensation"
                  placeholder="Enter compensation"
                  autocomplete="off"
                  value={compensation}
                  onChange={handleCompensationChange}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
            <div className="form-input-holder">
              <InputLebelComponent title="Location Requirement (optional)" />
              <div className="d-block">
                <input
                  type="text"
                  className="form-control"
                  id="location_requirement"
                  placeholder="Enter location requirement"
                  autocomplete="off"
                  value={locationRequirement}
                  onChange={handleLocationRequirementChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-block d-md-flex d-lg-flex d-xl-flex row">
          <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
            <div className="form-input-holder">
              <InputLebelComponent title="Other (optional)" />
              <div className="d-block">
                <input
                  type="text"
                  className="form-control"
                  id="other"
                  placeholder="Enter other requirements"
                  autocomplete="off"
                  value={other}
                  onChange={handleOtherChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const displaySubmitButton = () => {
    return (
      <Button
        variant="primary"
        disabled={isButtonDisabled}
        onClick={handleFormSubmit}
      >
        {buttonText}
      </Button>
    );
  };

  const displayCancelButton = () => {
    return (
      <Link to="/job/my-jobs">
        <Button
          variant="secondary"
          disabled={isButtonDisabled}
          className="me-3"
        >
          Cancel
        </Button>
      </Link>
    );
  };

  const displayStatusMessage = () => {
    return (
      <div className="d-block my-4">
        {displayErrorMessage()} {displaySuccessMessage()}
      </div>
    );
  };

  const displayErrorMessage = () => {
    if (hasSubmitError) {
      return <AlertDanger title={"Oops"} message={errorMessage} />;
    }
  };

  const displaySuccessMessage = () => {
    if (isValidSubmit) {
      return <AlertSuccess title={"Success"} message={successMessage} />;
    }
  };

  const displayFormBlock = () => {
    if (user_primary_role === "2" || user_primary_role === "4") {
      return (
        <>
          {displayTopBlock()}
          {displayForm()}
        </>
      );
    } else {
      return (
        <AlertInfo
          title={"Note"}
          message={"You do not have access to update job details"}
        />
      );
    }
  };

  return <div className="d-block">{displayMainContent()}</div>;
};

export default EditJobPosting;
